var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.848,
    height: 16.848,
    viewBox: "0 0 16.848 16.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download-solid",
    d: "M7.108,0H9.74a.788.788,0,0,1,.79.79V6.318h2.886A.657.657,0,0,1,13.88,7.44L8.875,12.448a.638.638,0,0,1-.9,0L2.965,7.44a.657.657,0,0,1,.464-1.122H6.318V.79A.788.788,0,0,1,7.108,0Zm9.74,12.373v3.686a.788.788,0,0,1-.79.79H.79a.788.788,0,0,1-.79-.79V12.373a.788.788,0,0,1,.79-.79H5.617L7.23,13.2a1.686,1.686,0,0,0,2.389,0l1.612-1.612h4.827A.788.788,0,0,1,16.848,12.373Zm-4.08,2.9a.658.658,0,1,0-.658.658A.66.66,0,0,0,12.768,15.269Zm2.106,0a.658.658,0,1,0-.658.658A.66.66,0,0,0,14.874,15.269Z",
    fill: "#f5f5f5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.0b68eb67b9ae3050b206895302502a72.svg";
export { ForwardRef as ReactComponent };